module.exports = __webpack_public_path__ + "assets/img/serve1.13c73654.png";